import { createAction } from '@reduxjs/toolkit';

export const shopPageNotFoundContainerActions = {
  navigateTo: createAction<{ navigateTo: string }>('ShopPageNotFoundContainer/NavigateTo'),
};
